import axios from 'axios'
const apiPath = '/api'
const openapi = '/openapi'
const encryptionJS = require('@/assets/js/encryption');
const baiduAiHttp = apiPath + '/congress-system/deepseek/v1/stream-chat'

// 登录
const loginFn = function name(params, obj) {
  let headers = {
    "signature": encryptionJS.generateSignature(encryptionJS.dataSort(obj)),
    "x-client": 'PC_LOGIN',
    'X-Requested-With': 'XMLHttpRequest',
    'X-Requested-System': 'platform',
  }
  if (params.captchaCode) {
    headers['X-CAPTCHA-TOKEN'] = params.captchaCode
  }
  let o = {
    password: encryptionJS.encrypt(params.password + ',' + obj.timestamp),
    username: encryptionJS.encrypt(params.username + ',' + obj.timestamp)
  }
  return axios.create({
    baseURL: apiPath,
    auth: o,
    headers: headers
  })
}
// 配置axios实例
const http = axios.create({
  baseURL: apiPath
})
const exportZip = axios.create({
  baseURL: apiPath,
  responseType: 'blob'
})
// 新版附件上传
const fileHttp = axios.create({
  baseURL: apiPath,
  responseType: 'arraybuffer'
})
// fileHttp拦截器
fileHttp.interceptors.request.use(
  config => {
    // 禁止axios自动转换数据，二进制必须保留
    config.transformRequest = [(data) => data]

    // ✅ 自动适配二进制Content-Type（没有类型就用通用二进制）
    const reqData = config.data
    if (reqData instanceof Blob || reqData instanceof ArrayBuffer) {
      config.headers['Content-Type'] = ''
    }
    return config
  },
  err => {
    return Promise.reject(err)
  })
// request拦截器
http.interceptors.request.use(
  config => {
    const token = sessionStorage.getItem('token') ? sessionStorage.getItem('token') : null
    if (token) {
      config.headers['X-Auth-Token'] = token
    }
    let obj = {
      timestamp: new Date().getTime()
    }
    if (config.method === 'get' || config.method === 'GET') {
      let params = config.params
      if (params && typeof params === "object" && !Array.isArray(params)) {
        obj = Object.assign(obj, params)
      }
      config.headers['signature'] = encryptionJS.generateSignature(encryptionJS.dataSort(obj))
      config.params = encryptionJS.dataSort(obj)
    } else {
      config.headers['signature'] = encryptionJS.generateSignature(encryptionJS.dataSort(obj))
      config.headers['timestamp'] = obj.timestamp
    }
    config.headers['X-Requested-With'] = 'XMLHttpRequest'
    config.headers['x-client'] = 'PC_LOGIN'
    config.headers['X-Requested-System'] = sessionStorage.getItem('systemType') ? sessionStorage.getItem('systemType') : 'platform'
    return config
  },
  err => {
    return Promise.reject(err)
  })
// 请求结束后
http.interceptors.response.use(function (response) {
  return encryptionJS.responseHandle(response)
}, function (error) {
  encryptionJS.responseHandleError(error)
  return Promise.reject(error)

})
// request拦截器
exportZip.interceptors.request.use(
  config => {
    const token = sessionStorage.getItem('token') ? sessionStorage.getItem('token') : null
    if (token) {
      config.headers['X-Auth-Token'] = token
    }
    let obj = {
      timestamp: new Date().getTime()
    }
    if (config.method === 'get' || config.method === 'GET') {
      let params = config.params
      if (params && typeof params === "object" && !Array.isArray(params)) {
        obj = Object.assign(obj, params)
      }
      config.headers['signature'] = encryptionJS.generateSignature(encryptionJS.dataSort(obj))
      config.params = encryptionJS.dataSort(obj)
    } else {
      config.headers['signature'] = encryptionJS.generateSignature(encryptionJS.dataSort(obj))
      config.headers['timestamp'] = obj.timestamp
    }
    config.headers['X-Requested-With'] = 'XMLHttpRequest'
    config.headers['x-client'] = 'PC_LOGIN'
    config.headers['X-Requested-System'] = sessionStorage.getItem('systemType') ? sessionStorage.getItem('systemType') : 'platform'
    return config
  },
  err => {
    return Promise.reject(err)
  })
// 请求结束后
exportZip.interceptors.response.use(function (response) {
  return encryptionJS.responseHandle(response)
}, function (error) {
  encryptionJS.responseHandleError(error)
  return Promise.reject(error)

})

export { http, exportZip, baiduAiHttp }
// 登录
export const login = async params => {
  let serverTimestamp;
  try {
    const res = await axios.get(`${openapi}/platform/sys/v1/time`);
    serverTimestamp = res.data;
  } catch (err) {
    serverTimestamp = new Date().getTime()
  }
  let obj = {
    timestamp: serverTimestamp
  }
  return loginFn(params, obj).get('/oauth2/v1/token?timestamp=' + obj.timestamp).then(response => {
    sessionStorage.setItem('token', response.data.token)
    sessionStorage.setItem('salt', response.data.salt)
    return response
  })
}

// 获取登录
export const loginBkInfo = params => {
  return http.get('captcha/v1/tenant', { params: params }).then(response => response)
}
// 刷新系统登录
export const refreshOauth = params => {
  return http.get('/oauth2/v1/refresh', { params: params }).then(response => response)
}
// 查询当前登录用户信息
export const getUserMsg = params => {
  return http.get('/oauth2/v1/me', { params: params }).then(response => response)
}
// 退出登录
export const logout = params => {
  return http.get('/oauth2/v1/logout', { params: params }).then(response => response)
}
// 查询区域
export const villagesPage = params => {
  return http.get('/sys/villages/v1/page', { params: params }).then(response => response)
}
// 添加区域
export const villagesAdd = params => {
  return http.post('/sys/villages/v1/operation', params).then(response => response)
}
// 编辑区域
export const villagesEdit = params => {
  return http.post('/sys/villages/v1/edit', params).then(response => response)
}
// 查询组
export const zuPage = params => {
  return http.get('/congress-party/villages/v1/page', { params: params }).then(response => response)
}
// 添加组
export const zuAdd = params => {
  return http.post('/congress-party/villages/v1/operation', params).then(response => response)
}
// 删除组
export const zuDelete = params => {
  return http.post('/congress-party/villages/v1/delete', params).then(response => response)
}
// 发送短信
export const sendCode = params => {
  return http.get('/oauth2/v1/phone/code', { params: params }).then(response => response)
}
// 短信登陆
export const phoneLogin = params => {
  return http.post('/oauth2/v1/phone/login', params).then(response => response)
}
// 菜单
export const menus = params => {
  if (!params.size) {
    params.size = 9999
  }
  params.sort = 'id,asc'
  return http.get('/auth/menus/v1/search', { params: params }).then(response => response)
}
// 添加菜单
export const addMenu = params => {
  return http.post('/auth/menus/v1/add', params).then(response => response)
}
// 租户关联系统菜单
export const tenantSysMenus = params => {
  return http.post('/initialization/v1/menus', params).then(response => response)
}
// 修改菜单
export const editMenu = params => {
  return http.put('/auth/menus/v1/modify', params).then(response => response)
}
// 删除菜单
export const deleteMenu = params => {
  return http.delete('/auth/menus/v1/delete', { data: params })
}
// 批量删除菜单
export const deleteMenus = params => {
  return http.delete('/auth/menus/v1/batch', { data: params })
}

// 查询角色page
export const groupsPage = params => {
  params.sort = params.sort || 'sortNo,id,asc'
  return http.get('/auth/groups/v1/page', { params: params }).then(response => response)
}
// 查询角色search
export const groupsSearch = params => {
  params.sort = params.sort || 'sortNo,id,asc'
  return http.get('/auth/groups/v1/search', { params: params }).then(response => response)
}
// 添加角色
export const groupsAdd = params => {
  return http.post('/auth/groups/v1/add', params).then(response => response)
}
// 修改角色
export const groupsEdit = params => {
  return http.put('/auth/groups/v1/modify', params).then(response => response)
}
// 删除角色
export const groupsDelete = params => {
  return http.delete('/auth/groups/v1/delete', { data: params })
}
// 根据角色导出用户
export const groupsExcelXlsx = params => {
  return exportZip.post('/sys/group/users/v1/excel-xlsx', params).then(response => response)
}
// 角色关联用户
export const groupsUsers = params => {
  return http.post('/auth/groups/members/v1/batch', params).then(response => response)
}
// 批量删除角色用户关联
export const deleteRelevance = params => {
  return http.delete('/auth/groups/members/v1/batch', { data: params }).then(response => response)
}
// 角色用户搜索
export const groupsUsersSearch = params => {
  params.size = 100
  return http.get('/auth/groups/members/v1/search', { params: params }).then(response => response)
}
// 角色用户Page
export const groupsUsersPage = params => {
  return http.get('/auth/groups/members/v1/page', { params: params }).then(response => response)
}

// 注册用户
export const registerUser = params => {
  return http.post('/auth/oauth2/v1/register', params).then(response => response)
}
// 用户page
export const usersPage = params => {
  return http.get('/auth/users/v1/page', { params: params }).then(response => response)
}
// 用户search
export const usersSearch = params => {
  return http.get('/auth/users/v1/search', { params: params }).then(response => response)
}
// 编辑用户信息
export const editUserInfo = params => {
  return http.put('/auth/users/v1/modify', params).then(response => response)
}
// 修改用户密码
export const editUserPwd = params => {
  return http.put('/auth/users/v1/change/password', params).then(response => response)
}
// 删除用户
export const deleteUser = params => {
  return http.delete('/auth/users/v1/delete', { data: params })
}

// 删除用户
export const userDelete = params => {
  return http.delete('/auth/tenants/members/v1/delete', { data: params })
}

// 用户批量关联角色
export const setUserRoles = params => {
  return http.post('/auth/groups/members/v1/user', params).then(response => response)
}

// 获取上传文件认证
export const getUploadAuthentication = params => {
  return http.get('/sys/files/v1/policy', { params: params }).then(response => response)
}
// 上传文件
export const fileUploadTwo = params => {
  let m = params.method.toLowerCase()
  return fileHttp[m](params.url, params.binaryData).then(response => response)
}
// 上传文件
export const fileUpload = params => {
  return http.post(params.url, params.obj).then(response => response)
}
// 删除文件
export const fileDelete = params => {
  return http.post('/sys/files/v1/remove', params).then(response => response)
}

// 查询已关联菜单
export const groupsAuthoritiesSearch = params => {
  return http.get('/auth/groups/authorities/v1/search', { params: params }).then(response => response)
}
// 查询已关联菜单
export const groupsAuthoritiesBatch = params => {
  return http.post('/auth/groups/authorities/v1/batch', params).then(response => response)
}
// 删除已关联菜单
export const groupsAuthoritiesDelete = params => {
  return http.delete('/auth/groups/authorities/v1/batch', { data: params }).then(response => response)
}
// 获取菜单
export const getMenus = params => {
  if (!params.size) {
    params.size = 9999
  }
  params.sort = 'id,asc'
  return http.get('/auth/menus/v1/me', { params: params }).then(response => response)
}
/* *---------------------数据字典-------------------- */
// 查询数据字典page
export const dictionaryPage = params => {
  return http.get('/sys/settings/v1/page', { params: params }).then(response => response)
}
// 查询数据字典search
export const dictionarySearch = params => {
  return http.get('/sys/settings/v1/search', { params: params }).then(response => response)
}
// 添加数据字典
export const dictionaryAdd = params => {
  return http.post('/sys/settings/v1/add', params).then(response => response)
}
// 修改数据字典
export const dictionaryModify = params => {
  return http.put('/sys/settings/v1/modify', params).then(response => response)
}
// 删除数据字典
export const dictionaryDelete = params => {
  return http.delete('/sys/settings/v1/delete', { data: params })
}

// 初始化租户
export const initTenantUser = params => {
  return http.post('/initialization/v1/tenant', params).then(response => response)
}
// 编辑租户
export const editTenant = params => {
  return http.put('/auth/tenants/v1/modify', params).then(response => response)
}
// 搜索租户
export const getTenantUserSearch = params => {
  return http.get('/auth/tenants/v1/search', { params: params }).then(response => response)
}
// 删除租户
export const deleteTenant = params => {
  return http.delete('/auth/tenants/v1/delete', { data: params }).then(response => response)
}
// 租户Page
export const getTenantPage = params => {
  return http.get('/auth/tenants/v1/page', { params: params }).then(response => response)
}

// 给租户关联用户
export const addRelanceuser = params => {
  return http.post('/auth/tenants/members/v1/batch', params).then(response => response)
}
// 添加租户用户
export const addTenantUser = params => {
  return http.post('/auth/tenants/members/v1/add', params).then(response => response)
}
// 删除租户用户
export const deleteTenantUser = params => {
  return http.delete('/auth/tenants/members/v1/delete', { data: params }).then(response => response)
}
// 租户用户page
export const getTenantUsersPage = params => {
  return http.get('/auth/tenants/members/v1/page', { params: params }).then(response => response)
}
// 平台日志
export const loggersPage = params => {
  return http.get('/sys/loggers/v1/page', { params: params }).then(response => response)
}
/* ------------组织------------ */
// 组织部门新增
export const addDept = params => {
  return http.post('/auth/dept/v1/add', params).then(response => response)
}
// 组织搜索
export const deptSearch = params => {
  return http.get('/auth/dept/v1/search', { params: params }).then(response => response)
}
// 组织部门编辑
export const editDept = params => {
  return http.put('/auth/dept/v1/modify', params).then(response => response)
}
// 组织部门删除
export const deleteDept = params => {
  return http.delete('/auth/dept/v1/delete', { data: params }).then(response => response)
}
/* ------------新闻------------ */
// 新闻添加
export const articleAdd = params => {
  return http.post('/sys/article/v1', params).then(response => response)
}
// 新闻查询page
export const articlePage = params => {
  return http.get('/sys/article/v1/page', { params: params }).then(response => response)
}
// 新闻查询search
export const articleSearch = params => {
  return http.get('/sys/article/v1/search', { params: params }).then(response => response)
}
// 新闻删除
export const articleDelete = params => {
  return http.delete('/sys/article/v1', { data: params }).then(response => response)
}
/* ------------新闻导航------------ */
// 新闻导航添加
export const navigationAdd = params => {
  return http.post('/sys/navigation/v1', params).then(response => response)
}

// 新闻导航查询page
export const navigationPage = params => {
  return http.get('/sys/navigation/v1/page', { params: params }).then(response => response)
}
// 新闻导航查询search
export const navigationSearch = params => {
  return http.get('/sys/navigation/v1/search', { params: params }).then(response => response)
}
// 新闻删除
export const navigationDelete = params => {
  return http.delete('/sys/navigation/v1', { data: params }).then(response => response)
}
/* ------------自定义列------------ */
// 添加
export const customcolumnsAdd = params => {
  return http.post('/sys/users/columns/v1/operate', params).then(response => response)
}
// 批量修改
export const customcolumnsBatch = params => {
  return http.post('/sys/users/columns/v1/batch', params).then(response => response)
}

// 查询page
export const customcolumnsPage = params => {
  return http.get('/sys/users/columns/v1/page', { params: params }).then(response => response)
}
// 查询search
export const customcolumnsSearch = params => {
  return http.get('/sys/users/columns/v1/search', { params: params }).then(response => response)
}
// 删除
export const customcolumnsDelete = params => {
  return http.delete('/sys/users/columns/v1/delete', { data: params }).then(response => response)
}
// 查询search
export const customcolumnsMe = params => {
  return http.get('/sys/users/columns/v1/me', { params: params }).then(response => response)
}
// 添加角色
export const addRoles = params => {
  return http.post('/oauth2/v1/tenant/cut', params).then(response => response)
}

/********************************
 *  届次管理*
 ********************************/
// 界次新增界次
export const addSubs = params => {
  return http.post('/congress-system/session/manage/v1', params).then(response => response)
}
// 届次查询page
export const subsPage = params => {
  return http.get('/congress-system/session/manage/v1/page', { params: params }).then(response => response)
}
// 届次查询seach
export const subsSearch = params => {
  return http.get('/congress-system/session/manage/v1/search', { params: params }).then(response => response)
}
// 届次删除
export const deleteSubs = params => {
  return http.delete('/congress-system/session/manage/v1', { data: params }).then(response => response)
}
// 届次开启
export const startSubs = params => {
  return http.post('/congress-system/session/manage/v1/activate', params).then(response => response)
}

// 查询用户组织信息
export const usereDlegation = params => {
  return http.get('/congress-member/rep/query/userid', { params: params }).then(response => response)
}
// 获取所有组织
export const getAlldeptInfo = params => {
  return http.get('/sys/organization/v1/search', { params: params }).then(response => response)
}
// 用户关联组织
export const releverDept = params => {
  return http.post('/congress-member/rep/v1/to/user', params).then(response => response)
}

// 根据组织查用户
export const deleteReleveDept = params => {
  return http.delete('/congress-member/rep/v1/delete/user', { data: params }).then(response => response)
}
// 添加组织
export const addDepartment = params => {
  return http.post('/sys/organization/v1', params).then(response => response)
}
// 删除组织
export const deleteDepartmentById = params => {
  return http.delete(`/sys/organization/v1/${params.id}` + '?executor=' + params.username).then(response => response)
}

// 通知公告page
export const getNoticesPage = params => {
  return http.get('/sys/notices/v1/page', { params: params }).then(response => response)
}

// 添加通知公告
export const addNotices = params => {
  return http.post('/sys/notices/v1/add', params).then(response => response)
}

// 编辑通知公告
export const editNotices = params => {
  return http.put('/sys/notices/v1/modify', params).then(response => response)
}

// 删除通知公告
export const deleteNotices = params => {
  return http.delete('/sys/notices/v1/delete', { data: params }).then(response => response)
}

// 添加用户常用
export const usedMenuAdd = params => {
  return http.post('sys/users/menus/v1/add', params).then(response => response)
}

// 查询用户常用
export const usedMenuSearch = params => {
  return http.get('sys/users/menus/v1/search', { params: params }).then(response => response)
}

/********************************
 *  短信配置*
 ********************************/
// 查询短信
export const messageSearch = params => {
  return http.get('sys/short/message/v1/page', { params: params }).then(response => response)
}
// 增加
export const messageAdd = params => {
  return http.post('sys/short/message/v1/add', params).then(response => response)
}

// 修改f
export const messageModify = params => {
  return http.put('sys/short/message/v1/modify', params).then(response => response)
}
// 查询短信
export const messageDelete = params => {
  return http.delete('sys/short/message/v1/delete', { data: params }).then(response => response)
}

/********************************
 *  使用指南*
 ********************************/
// 增加
export const manualAdd = params => {
  return http.post('sys/manual/v1', params).then(response => response)
}

// 查询
export const manualSearch = params => {
  return http.get('sys/manual/v1/page', { params: params }).then(response => response)
}

// 删除
export const manualDel = params => {
  return http.delete(`sys/manual/v1/${params.id}`).then(response => response)
}

/**********************************
 * 通讯录分组 *
 * *******************************/
// 查询
export const contactsPage = params => {
  return http.get('/platform-member/contacts/v1/page', { params }).then(response => response)
}
// 查询
export const contactsSearch = params => {
  return http.get('/platform-member/contacts/v1/search', { params }).then(response => response)
}
// 添加修改
export const contactsPost = params => {
  return http.post('/platform-member/contacts/v1', params).then(response => response)
}
// 删除
export const contactsDelete = params => {
  return http.delete('/platform-member/contacts/v1', { data: params }).then(response => response)
}
// 批量删除
export const contactsMemberDeleteS = params => {
  return http.delete('/platform-member/contacts/member/v1/deletes', { data: params }).then(response => response)
}
// 查询
export const contactsMemberPage = params => {
  return http.get('/platform-member/contacts/member/v1/page', { params }).then(response => response)
}
// 租户分组是否共享
export const setContactsShare = params => {
  return http.post('/platform-member/contacts/v1/modify/share', params).then(response => response)
}

// 添加修改
export const contactsMemberPost = params => {
  return http.post('/platform-member/contacts/member/v1', params).then(response => response)
}
// 查询用户
export const getUsersSearch = params => {
  return http.get('/auth/tenants/members/v1/search', { params: params }).then(response => response)
}
// 查询
export const contactsMemberSearch = params => {
  return http.get('/platform-member/contacts/member/v1/search', { params: params }).then(response => response)
}
// 设置通讯录人是否公开
export const setMemberOpen = params => {
  return http.post('/platform-member/contacts/member/v1/modify/open', params).then(response => response)
}
// 设置通讯录人手机号是否公开
export const setMemberPhotoOpen = params => {
  return http.post('/platform-member/contacts/member/v1/modify/restricted', params).then(response => response)
}

// 复制租户
export const copyTenant = params => {
  return http.post('/initialization/v1/copy', params).then(response => response)
}

// 查敏感词
export const sensitiveVocabularyPage = params => {
  return http.get('/congress-system/sensitive/vocabulary/v1/page', { params }).then(response => response)
}
// 添加敏感词
export const sensitiveVocabularyAdd = params => {
  return http.post('/congress-system/sensitive/vocabulary/v1', params).then(response => response)
}
// 复制敏感词
export const sensitiveVocabularyCopy = params => {
  return http.post('/congress-system/sensitive/vocabulary/v1/copy', params).then(response => response)
}

// 删除敏感词
export const sensitiveVocabularyDelete = params => {
  return http.delete('/congress-system/sensitive/vocabulary/v1', { data: params })
}

// 查询黑名单
export const blacklistSearch = params => {
  return http.get('/auth/blacklist/v1/search', { params }).then(response => response)
}
// 添加黑名单
export const blacklistAdd = params => {
  return http.post('/auth/blacklist/v1/save', params).then(response => response)
}
// 删除敏感词
export const blacklistDelete = params => {
  return http.delete('/auth/blacklist/v1/delete', { data: params })
}
// 编辑用户账号
export const eidtUsername = params => {
  return http.post('/auth/users/v1/modify/username', params).then(response => response)
}
// 在删除按钮时同时删除所有租户下所有角色的相应按钮权限， 带租户只更改改租户下的所有角色按钮权限
export const deleteBtnAuthor = params => {
  return http.delete('/auth/groups/authorities/v1/delete', { data: params }).then(response => response)
}
// 提案备选状态添加
export const addCppccStatus = params => {
  return http.post('/sys/settings/auto/v1/add', params).then(response => response)
}

// 修改提案备选状态
export const editCppccStatus = params => {
  return http.put('/sys/settings/auto/v1/modify', params).then(response => response)
}
// 提案备选状态添加
export const cppccStatusPage = params => {
  return http.get('/sys/settings/auto/v1/page', { params }).then(response => response)
}

// 删除提案备选状态
export const cppccStatusDelete = params => {
  return http.delete('/sys/settings/v1/auto/delete', { data: params })
}
// 添加大屏菜单
export const addLargeScreenMenu = params => {
  return http.post('/congress-system/large/screen/v1', params).then(response => response)
}
// 大屏菜单page
export const getlargeScreenPage = params => {
  return http.get('/congress-system/large/screen/v1/page', { params }).then(response => response)
}
// 大屏菜单search
export const getlargeScreenSearch = params => {
  return http.get('/congress-system/large/screen/v1/search', { params }).then(response => response)
}

// 删除大屏菜单
export const largeSreenMenuDelete = params => {
  return http.delete('/congress-system/large/screen/v1', { data: params }).then(response => response)
}

// 热词复制
export const hotWordCopy = params => {
  return http.post('/congress-system/hot/words/v1/copy', params).then(response => response)
}
// 热词关注点
export const featureWordsCopy = params => {
  return http.post('/congress-system/feature/words/v1/initialize', params).then(response => response)
}

export const problemAdd = params => {
  return http.post('/congress-system/common/problem/v1', params).then(response => response)
}
export const problemPage = params => {
  return http.get('/congress-system/common/problem/v1/page', { params: params }).then(response => response)
}
export const problemSearch = params => {
  return http.get('/congress-system/common/problem/v1/search', { params: params }).then(response => response)
}
export const problemDelete = params => {
  return http.delete('/congress-system/common/problem/v1', { data: params }).then(response => response)
}

export const problemEvaluateSearch = params => {
  return http.get('/congress-system/common/problem/evaluate/v1/search', { params }).then(response => response)
}

// ai配置
export const deepseekPage = params => {
  return http.get('/congress-system/deepseek/v1/page', { params: params }).then(response => response)
}
export const deepseekAdd = params => {
  return http.post('/congress-system/deepseek/v1', params).then(response => response)
}
export const deepseekDelete = params => {
  return http.delete('/congress-system/deepseek/v1', { data: params }).then(response => response)
}

// ai小助手配置
export const deepseekAgentPage = params => {
  return http.get('/sys/deepseek/agent/v1/page', { params: params }).then(response => response)
}
export const deepseekAgentAdd = params => {
  return http.post('/sys/deepseek/agent/v1', params).then(response => response)
}
export const deepseekAgentDelete = params => {
  return http.delete('/sys/deepseek/agent/v1', { data: params }).then(response => response)
}

// 授权添加/修改
export const authorizationEffectAdd = params => {
  return http.post('/sys/authorization/effect/v1', params).then(response => response)
}
// 授权查询
export const authorizationEffectPage = params => {
  return http.get('/sys/authorization/effect/v1/page', { params: params }).then(response => response)
}
export const authorizationEffectDelete = params => {
  return http.delete('/sys/authorization/effect/v1/' + params.id, { data: params }).then(response => response)
}

// 授权日志
export const authorizationLoggerPage = params => {
  return http.get('/sys/authorization/logger/v1/page', { params: params }).then(response => response)
}
export const authorizationLoggerDelete = params => {
  return http.delete('/sys/authorization/logger/v1/' + params.id, { data: params }).then(response => response)
}


// 授权管理查询
export const tenantsDockingPage = params => {
  return http.get('/auth/tenants/docking/v1/page', { params: params }).then(response => response)
}
// 授权管理添加
export const tenantsDockingAdd = params => {
  return http.post('/auth/tenants/docking/v1', params).then(response => response)
}
// 授权管理启用切换
export const tenantsDockingEnable = params => {
  return http.post('/auth/tenants/docking/v1/enable', params).then(response => response)
}
// 授权管理启用删除
export const tenantsDockingDelete = params => {
  return http.delete('/auth/tenants/docking/v1/' + params.tenantCode + '/' + params.systemType, params).then(response => response)
}
export const tenantsDockingExport = params => {
  return http.get('/auth/tenants/docking/v1/export', { params }).then(response => response)
}
// 获取联络站
export const getAllLiaisonSearch = params => {
  return http.get('/platform-member/liaison/stations/v1/search', { params: params }).then(response => response)
}
// 查询所有代表信息
export const representativeAllPage = params => {
  return http.get('/platform-member/member/statistics/v1/name-key', { params: params }).then(response => response)
}
// 查询代表信息Page
export const representativePagePost = params => {
  return http.post('/platform-member/rep/page-post', params).then(response => response)
}
// 根据组织查用户
export const representativePage = params => {
  return http.get('/platform-member/rep/page', { params: params }).then(response => response)
}
// 祝贺提示添加
export const memberFelicitateOperate = params => {
  return http.post('/platform-member/member/felicitate/v1/operate', params).then(response => response)
}
// 祝贺提示删除
export const memberFelicitateDelete = params => {
  return http.delete('/platform-member/member/felicitate/v1', { data: params }).then(response => response)
}
// 祝贺提示查询
export const memberFelicitateDeletePage = params => {
  return http.get('/platform-member/member/felicitate/v1/page', { params: params }).then(response => response)
}
